import React from 'react';

export const SectionHeader: React.FC<{ title: string; description?: string; trailing?: React.ReactNode }> = ({ title, description, trailing }) => (
    <div className="mb-4 flex items-start justify-between gap-4">
        <div>
            <h3 className="text-lg font-semibold">{title}</h3>
            {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
        </div>
        {trailing}
    </div>
);

/** `React.Dispatch<SetStateAction<T>>` that also flags the draft dirty. */
export type DirtySetter<T> = (value: React.SetStateAction<T>) => void;
